module.exports = __webpack_public_path__ + "static/how_it_works_life_art-d96579c4802cd34c7329d3c00f5992f8.png";